import { render, staticRenderFns } from "./EN.vue?vue&type=template&id=4d5bc0fa&scoped=true&"
import script from "./EN.vue?vue&type=script&lang=js&"
export * from "./EN.vue?vue&type=script&lang=js&"
import style0 from "./EN.vue?vue&type=style&index=0&id=4d5bc0fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5bc0fa",
  null
  
)

export default component.exports